const Programs = () => {
    return (
        <div>
            <p>This is Programs page</p>
        </div>
    )
}

export default Programs